import { createContext, ReactNode, useContext } from "react";
import { GetMySettingsQuery } from "gql/graphql";
import { useMySettingsData } from "./use-my-settings-data";

type UserSettingsContext = {
  settings: GetMySettingsQuery["getMySettings"];
};

export const UserSettingsContext = createContext<UserSettingsContext | null>(
  null,
);

export function UserSettingsProvider({ children }: { children: ReactNode }) {
  const { settings } = useMySettingsData();

  if (!settings) {
    return null;
  }

  return (
    <UserSettingsContext.Provider
      value={{
        settings,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
}

export function useUserSettings() {
  const ctx = useContext(UserSettingsContext);

  if (ctx === null) {
    throw new Error("useUserSettings must be used within UserSettingsProvider");
  }

  return ctx;
}
